import { auth } from '../Db/FirebaseConfig'
import { onAuthStateChanged } from "firebase/auth"

export async function CurrentUser() {
    return new Promise(function (resolve) {
        onAuthStateChanged(auth, user => resolve(user))
    })
}
